import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';

type PreviewChatItemSuggestionsProps = {
  suggestions: string[];
  onSelect?: (suggestion: string) => void;
  className?: string;
  itemClassName?: string;
};

export function PreviewChatItemSuggestions({
  suggestions,
  onSelect,
  className,
  itemClassName,
}: PreviewChatItemSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className={cn('mt-2 flex flex-col flex-wrap gap-2', className)}>
      {suggestions.map((suggestion, index) => (
        <Button
          key={`${suggestion}-${index}`}
          type="button"
          variant="ghost"
          className={cn(
            'h-auto w-fit justify-start whitespace-normal px-0 text-left text-primary hover:text-primary',
            itemClassName
          )}
          onClick={() => onSelect?.(suggestion)}
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
}
